import React from "react";
import { AxiosError, AxiosResponse } from "axios";
import { createApi } from "../../../utils/createApi";
import { markSiteUnsynced } from "../../../utils/syncStore";
import { IgnoreZonesBreadCrumbs } from "../../EditIgnoreZones/IgnoreZonesBreadCrumbs";
import { createIgnoreZonesLinksArray } from "../../EditIgnoreZones/EditIgnoreZonesUtils/createIgnoreZonesLinksArray";
import { universalAPIErrorHandler } from "../../../utils/universalAPIErrorHandler";
import { BoldAlertsTab } from "../BoldAlertsTab";
import { getNumbersAfterEditCamera, getNumbersAfterSites } from "../EditCamera";
import ErrorBoundary from "../../../../ErrorBoundary";
import { AlertSettingsTab } from "../AlertSettingsTab";
import { useEditCameraStore } from "../editCameraStore/editCameraStore";

export const handleSubmitNewBoldAlert = async (
  cameraGeneralInfo: any,
  boldAlerts: any,
  postObject: any,
  navigate: any,
  setBackdropLoadingScreenOn: any,
  setCameraGeneralInfo: any,
  setCameraGeneralInfoBackup: any,
  setGeneralInfoChangesMade: any,
  setPatchObject: any,
  setBoldAlerts: any,
  setActiveTab: any,
  setAddBoldAlertDialogOpen: any,
  cameraGeneralInfoBackup: any,
  setIgnoreZonesBreadCrumbs: any,
  handleSitesBreadcrumbClick: any,
  handleSingularSiteBreadcrumbClick: any,
  immixAlerts: any,
  setAddImmixAlertDialogOpen: any,
  setSendingImmixTest: any,
  setImmixTestSuccessDialogOpen: any,
  setImmixTestFailDialogOpen: any,
  setDeleteImmixAlertDialogOpen: any,
  sureviewAlerts: any,
  setAddSureviewAlertDialogOpen: any,
  cameraWebhookData: any,
  setAddStreamWebhookDialogOpen: any,
  setEditStreamWebhookDialogOpen: any,
  sentinelAlerts: any,
  setAddSentinelAlertDialogOpen: any,
  patriotAlerts: any,
  setAddPatriotAlertDialogOpen: any,
  softguardAlerts: any,
  setAddSoftguardAlertDialogOpen: any,
  immixAlertsOnCamera: any,
  sureViewAlertsOnCamera: any,
  siteInfo: any,
  webhooksAlertsOnCamera: any,
  sentinelAlertsOnCamera: any,
  boldAlertsOnCamera: any,
  patriotAlertsOnCamera: any,
  softguardAlertsOnCamera: any,
  evalinkAlertsOnCamera: boolean
) => {
  const AxiosUI = createApi(``);
  const retryFunction = () => {
    handleSubmitNewBoldAlert(
      cameraGeneralInfo,
      boldAlerts,
      postObject,
      navigate,
      setBackdropLoadingScreenOn,
      setCameraGeneralInfo,
      setCameraGeneralInfoBackup,
      setGeneralInfoChangesMade,
      setPatchObject,
      setBoldAlerts,
      setActiveTab,
      setAddBoldAlertDialogOpen,
      cameraGeneralInfoBackup,
      setIgnoreZonesBreadCrumbs,
      handleSitesBreadcrumbClick,
      handleSingularSiteBreadcrumbClick,
      immixAlerts,
      setAddImmixAlertDialogOpen,
      setSendingImmixTest,
      setImmixTestSuccessDialogOpen,
      setImmixTestFailDialogOpen,
      setDeleteImmixAlertDialogOpen,
      sureviewAlerts,
      setAddSureviewAlertDialogOpen,
      cameraWebhookData,
      setAddStreamWebhookDialogOpen,
      setEditStreamWebhookDialogOpen,
      sentinelAlerts,
      setAddSentinelAlertDialogOpen,
      patriotAlerts,
      setAddPatriotAlertDialogOpen,
      softguardAlerts,
      setAddSoftguardAlertDialogOpen,
      immixAlertsOnCamera,
      sureViewAlertsOnCamera,
      siteInfo,
      webhooksAlertsOnCamera,
      sentinelAlertsOnCamera,
      boldAlertsOnCamera,
      patriotAlertsOnCamera,
      softguardAlertsOnCamera,
      evalinkAlertsOnCamera
    );
  };

  let postPatchObjectFail = false;
  let getSiteCamerasFail = false;

  const { setCameraStreamsPatchObject, setCameraStreamsObject } =
    useEditCameraStore.getState();

  await AxiosUI.patch(
    `/camera/${getNumbersAfterEditCamera(location.href)}/general_info/`,
    {
      streams: postObject,
    }
  ).then(
    (response: AxiosResponse) => {
      postPatchObjectFail = false;
      markSiteUnsynced();
      setCameraGeneralInfo(response.data);
      setCameraGeneralInfoBackup(response.data);
      setCameraStreamsPatchObject(response.data.streams);
      setCameraStreamsObject(response.data.streams);
      const pushedArray: any[] = [];
      response.data.streams[0].bold_alerts.forEach((alertObject: any) => {
        pushedArray.push(alertObject);
      });
      setBoldAlerts(pushedArray);
      setGeneralInfoChangesMade(false);
      setPatchObject({});
      setActiveTab(
        <ErrorBoundary>
          <AlertSettingsTab
            immixAlerts={immixAlerts}
            setAddImmixAlertDialogOpen={setAddImmixAlertDialogOpen}
            setSendingImmixTest={setSendingImmixTest}
            setImmixTestSuccessDialogOpen={setImmixTestSuccessDialogOpen}
            setImmixTestFailDialogOpen={setImmixTestFailDialogOpen}
            setDeleteImmixAlertDialogOpen={setDeleteImmixAlertDialogOpen}
            sureviewAlerts={sureviewAlerts}
            setAddSureviewAlertDialogOpen={setAddSureviewAlertDialogOpen}
            setAddStreamWebhookDialogOpen={setAddStreamWebhookDialogOpen}
            setEditStreamWebhookDialogOpen={setEditStreamWebhookDialogOpen}
            sentinelAlerts={sentinelAlerts}
            setAddSentinelAlertDialogOpen={setAddSentinelAlertDialogOpen}
            boldAlerts={pushedArray}
            setAddBoldAlertDialogOpen={setAddBoldAlertDialogOpen}
            patriotAlerts={patriotAlerts}
            setAddPatriotAlertDialogOpen={setAddPatriotAlertDialogOpen}
            softguardAlerts={softguardAlerts}
            setAddSoftguardAlertDialogOpen={setAddSoftguardAlertDialogOpen}
            immixAlertsOnCamera={immixAlertsOnCamera}
            sureViewAlertsOnCamera={sureViewAlertsOnCamera}
            siteInfo={siteInfo}
            webhooksAlertsOnCamera={webhooksAlertsOnCamera}
            sentinelAlertsOnCamera={sentinelAlertsOnCamera}
            boldAlertsOnCamera={boldAlertsOnCamera}
            patriotAlertsOnCamera={patriotAlertsOnCamera}
            softguardAlertsOnCamera={softguardAlertsOnCamera}
            evalinkAlertsOnCamera={evalinkAlertsOnCamera}
            navigate={navigate}
          />
        </ErrorBoundary>
      );
      setBackdropLoadingScreenOn(false);
    },
    (reason: AxiosError) => {
      postPatchObjectFail = true;
      universalAPIErrorHandler(reason, navigate, retryFunction, () => {
        setCameraGeneralInfo(cameraGeneralInfoBackup);
        setPatchObject({
          camera_name: cameraGeneralInfoBackup.camera_name,
          streams: cameraGeneralInfoBackup.streams,
        });
        setBackdropLoadingScreenOn(false);
      });
    }
  );
  !postPatchObjectFail &&
    (await AxiosUI.get(
      `camera/site/?customer__id=${getNumbersAfterSites(location.href)}`
    ).then(
      (response: AxiosResponse) => {
        getSiteCamerasFail = false;
        localStorage.setItem("siteCameras", JSON.stringify(response.data));
      },
      (reason: AxiosError) => {
        universalAPIErrorHandler(reason, navigate, retryFunction, () => {
          getSiteCamerasFail = true;
        });
      }
    ));
  !postPatchObjectFail &&
    !getSiteCamerasFail &&
    (await AxiosUI.get(
      `customer/${getNumbersAfterSites(location.href)}/about/`
    ).then(
      (response: AxiosResponse) => {
        localStorage.setItem("siteInfo", JSON.stringify(response.data));
        localStorage.setItem("integrationType", response.data.integration_type);
        setIgnoreZonesBreadCrumbs(
          <IgnoreZonesBreadCrumbs
            linksArray={createIgnoreZonesLinksArray(response.data.breadcrumbs)}
            handleSitesBreadcrumbClick={handleSitesBreadcrumbClick}
            handleSingularSiteBreadcrumbClick={
              handleSingularSiteBreadcrumbClick
            }
            styling="absolute top-[10px] left-[30px]"
          />
        );
      },
      (reason: AxiosError) => {
        universalAPIErrorHandler(reason, navigate, retryFunction, () => {
          setBackdropLoadingScreenOn(false);
        });
      }
    ));
};
